var React = require('react');

function PencilCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","fill":"none"},[React.createElement("path",{"d":"M10.661 16.168l-4.95 2.122 2.122-4.951 8.839-8.839 2.828 2.829zM17.664 9.165l-2.828-2.829M10.661 16.168l-2.828-2.829","key":0}),React.createElement("circle",{"cx":"12","cy":"12","r":"11.5","key":1})]));
}

PencilCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = PencilCircle;

PencilCircle.default = PencilCircle;
